import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  Popper,
  Radio,
  RadioGroup,
  Typography,
  Popover,
  Paper,
  Grid,
} from "@mui/material";
// import styles from "styles/component/Popper.module.scss";
import styles from "styles/component/CustomPopover.module.scss";

import asset from "json/assets";
import { hittingAreasPrimay, hittingAreasType } from "json/constants";

export const HittingAreaMarker = (props) => {
  const {
    markerType,
    handleChangeMarkerType,
    selectedMarkerMod2,
    handelChangeMarkerColor,
    errorMsg,
    handleSave,
    errorComponent
  } = props;
//landingAreasType
 
  return (
    <Box className={styles.popover_body_new}>
      {/* <MultiSelect /> */}
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">SELECT TYPE</FormLabel>
        <RadioGroup
          className={styles.marker_option}
          aria-labelledby="demo-radio-buttons-group-label"
          // defaultValue="FLAG"
          name="radio-buttons-group"
          value={markerType}
          onChange={handleChangeMarkerType}
        >
          {hittingAreasType?.map((marker, index) => (
            <FormControlLabel
              value={marker.value}
              control={<Radio checked={marker.value===markerType}/>}
              label={marker.label}
              key={index}
            />
          ))}
        </RadioGroup>

        <FormLabel id="demo-radio-buttons-group-label2">PRIMARY</FormLabel>
        <RadioGroup
          className={styles.marker_option}
          aria-labelledby="demo-radio-buttons-group-label"
          // defaultValue="RED"
          name="radio-buttons-group"
          value={selectedMarkerMod2}
          onChange={handelChangeMarkerColor}
        >
          {hittingAreasPrimay?.map((marker, index) => (
            <FormControlLabel 
            // style={{padding:"10px 20px"}}
              value={marker.value}
              control={<Radio checked={marker.value===selectedMarkerMod2}/>}
              label={marker.label}
              key={index}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {errorMsg && errorComponent()}
      <Box className={styles.popover_ftr}>
        <Button
          to={"#"}
          className={styles.blue_btn}
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};
